import { Popup } from '@Common/Controls/Popup';
import urlHelper from '@Common/Helpers/UrlHelper';

export function about(): void {
    const $body = $('body');
    const popup = new Popup();

    const root = $('<div/>', {
        class: 'about',
        html: [
            $('<div/>', {
                class: 'logo',
                css: {
                    backgroundImage: urlHelper.getCssImageUrl(`Logo/${altosoft.appId}.png`)
                }
            }),
            $('<div/>', {
                class: 'version',
                html: altosoft.version
            }),
            $('<div/>', {
                class: 'copy',
                html: strings.copyright
            })
        ],
        on: {
            click: () => popup.close()
        }
    });

    popup.setContent(root).show(($body.outerWidth() - root.outerWidth()) / 2, ($body.outerHeight() - root.outerHeight()) / 2);
}
